var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center p-4 bg-light",attrs:{"id":"nav"}},[_c('img',{attrs:{"src":require("../src/assets/logo_bimedia.png"),"height":"90","width":"300"}})])
}]

export { render, staticRenderFns }